module.exports = __webpack_public_path__ + "static/media/templateResolution.b59e03e7.svg";